import React from "react"
import { Link } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"

// Set to "legacy" to instantly revert to your previous homepage layout.
const HOME_VARIANT = "styled"
const newTabProps = { target: "_blank", rel: "noopener noreferrer" }

const content = {
  intro:
    "Hey there, I’m Sean! 👋 I’m based out of San Francisco where I work in the private equity group at Bain.",
  para1:
    "Previously, I was a marketer at Stitch Fix and a jack-of-all-trades working across engineering, product, growth, and strategy/ops at various startups from pre-seed to Series E.",
  para2:
    "As an undergrad, I studied political science and computer science at Swarthmore College and the University of Oxford.",
  para3:
    "I founded my school’s startup accelerator and entrepreneurship community, worked as a fellow with Bessemer Venture Partners and True Ventures, and launched several projects that have since helped thousands of people.",
  para4:
    "In my free time, I enjoy learning about history, writing stories, and hanging out with friends/family.",
}

function ExperienceParagraph() {
  return (
    <p>
      I founded my school’s startup accelerator and{" "}
      <a href="https://swarthmorelaunchdeck.com/" {...newTabProps}>
        entrepreneurship community
      </a>, worked as a fellow with{" "}
      <a
        href="https://www.bvp.com/news/bessemers-2022-fellowship-class"
        {...newTabProps}
      >
        Bessemer Venture Partners
      </a>{" "}
      and{" "}
      <a
        href="https://trueventures.com/true-platform/fellowships/alumni"
        {...newTabProps}
      >
        True Ventures
      </a>, and launched{" "}
      <Link to="/projects" {...newTabProps}>
        several projects
      </Link>{" "}
      that have since helped thousands of people.
    </p>
  )
}

function LegacyHome() {
  return (
    <div style={{ fontFamily: "Inter", fontWeight: "400" }}>
      <p>{content.intro}</p>
      <p>{content.para1}</p>
      <p>{content.para2}</p>
      <ExperienceParagraph />
      <p>{content.para4}</p>
      <p>
        <strong>Contact</strong>
        <br />
        <a href="mailto:sean.cheng@bain.com" {...newTabProps}>
          sean.cheng@bain.com
        </a>
        <br />
        <a href="https://x.com/sean_cheng_" {...newTabProps}>
          X
        </a>{" "}
        /{" "}
        <a href="https://www.linkedin.com/in/sean-c-7b0a31192/" {...newTabProps}>
          LinkedIn
        </a>
      </p>
    </div>
  )
}

function StyledHome() {
  return (
    <div
      style={{
        fontFamily: "Inter, sans-serif",
        color: "#111827",
      }}
    >
      <section
        style={{
          background:
            "linear-gradient(140deg, rgba(127,29,29,0.09), rgba(15,23,42,0.03))",
          border: "1px solid rgba(127,29,29,0.16)",
          borderRadius: "18px",
          padding: "28px 24px",
          marginBottom: "22px",
        }}
      >
        <div
          style={{
            display: "inline-block",
            fontSize: "15px",
            color: "#7f1d1d",
            fontWeight: 600,
            marginBottom: "10px",
          }}
        >
          📍 San Francisco
        </div>
        <p style={{ marginBottom: 0, fontSize: "20px", lineHeight: "1.5" }}>
          {content.intro}
        </p>
      </section>

      <section
        style={{
          borderLeft: "3px solid #7f1d1d",
          paddingLeft: "16px",
          marginBottom: "24px",
        }}
      >
        <p>{content.para1}</p>
        <p>{content.para2}</p>
        <ExperienceParagraph />
        <p style={{ marginBottom: 0 }}>{content.para4}</p>
      </section>

      <section
        style={{
          display: "grid",
          gap: "8px",
          backgroundColor: "#f9fafb",
          border: "1px solid #e5e7eb",
          borderRadius: "14px",
          padding: "16px",
        }}
      >
        <div
          style={{
            fontSize: "12px",
            letterSpacing: "0.08em",
            textTransform: "uppercase",
            color: "#6b7280",
            fontWeight: 700,
          }}
        >
          Contact
        </div>
        <a href="mailto:sean.cheng@bain.com" {...newTabProps}>
          sean.cheng@bain.com
        </a>
        <div>
          <a href="https://x.com/sean_cheng_" {...newTabProps}>
            X
          </a>{" "}
          /{" "}
          <a href="https://www.linkedin.com/in/sean-c-7b0a31192/" {...newTabProps}>
            LinkedIn
          </a>
        </div>
      </section>
    </div>
  )
}

function IndexPage(props) {
  const siteTitle = "Sean Cheng"

  return (
    <Layout location={props.location} title={siteTitle}>
      <SEO title="Home" keywords={[`blog`, `gatsby`, `javascript`, `react`]} />
      {HOME_VARIANT === "legacy" ? <LegacyHome /> : <StyledHome />}
    </Layout>
  )
}

export default IndexPage
